import { Component } from '@angular/core';

@Component({
  selector: 'app-integrations',
  imports: [],
  templateUrl: './integrations.component.html',
  styleUrl: './integrations.component.scss'
})
export class IntegrationsComponent {

}
